import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters(['authUser', 'authToken', 'authCheck', 'shadowToken', 'afterLoginRoute']),
    user() {
      return this.authUser
    },
    userDataMeta() {
      return this.user && {...this.user.meta || {}, ...this.user} || {}
    },
    authenticated() {
      return this.authCheck
    },
    needsLogin() {
      return !this.authCheck
    },
    needsVerification() {
      return this.user && !(1 * this.user.verified)
    }
  },
  methods: {
    ...mapActions(['saveToken', 'pingUser', 'fetchUser', 'updateUser', 'saveShadowToken', 'authGuard', 'logout', 'rememberAfterLoginRoute'])
  }
}
